import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
// components
import { FormProvider, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { DialogContent, DialogActions, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';

import { TextFieldBase } from '../../components/inputs/TextFieldBase';
import { withFormController } from '../../components/hocs/forms';
import CBButton from '../../components/Buttons/CbButton';
import { toggleModalDirect } from '../../utils/storeUtils';
import { qualysConnect } from './ConnectorService';
import { PubSub } from '../../utils/eventUtils';
import { CONNECTOR_TYPES } from './connectors.constants';

// helpers

const TextField = withFormController(TextFieldBase);
const schema = Yup.object().shape({
  username: Yup.string().required('API User is required'),
  password: Yup.string().required('Password is required'),
});

const QualysForm = ({ classes, data }: any) => {
  const { cbid } = data;
  const { enqueueSnackbar } = useSnackbar();
  const defaultValues = {
    username: '',
    password: '',
  };

  const { handleSubmit, ...methods } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    formState: { isSubmitting },
  } = methods;

  const onSubmit = (formData: any) => {
    const payload = formData;
    const modifiedPayload = {
      connector: CONNECTOR_TYPES.QUALYSVM,
      provider: 'COWBELL',
      credentials: {
        username: payload.username,
        password: payload.password,
      },
      cbid,
      metadata: null,
    };
    return qualysConnect({}, modifiedPayload)
      .then(() => {
        toggleModalDirect('QualysForm', false);
        PubSub.publish('connector-page-refetch', true);
      })
      .catch(() => {
        enqueueSnackbar('Failed to connect, please try again later', {
          variant: 'error',
        });
      });
  };

  const handleCancel = () => {
    toggleModalDirect('QualysForm', false);
  };

  return (
    <section className={classes.cardContentContainer}>
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent classes={{ root: classes.container }}>
            <Grid
              container
              justifyContent="left"
              className={classes.inputFields}
            >
              <Grid item md={10}>
                <TextField
                  name="username"
                  label="API User"
                  fullWidth
                  required
                />
              </Grid>
              <Grid item md={10}>
                <TextField
                  name="password"
                  label="Password"
                  type="password"
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <CBButton action={handleCancel} styleName="cancel">
              Cancel
            </CBButton>
            <CBButton
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              styleName="ctaButton"
              buttonText="Connect"
            />
          </DialogActions>
        </form>
      </FormProvider>
    </section>
  );
};

const styles = ({ palette }: any) => {
  return {
    description: {
      fontSize: '1.167rem',
      color: palette.primary.main,
      lineHeight: 1.5,
      fontStyle: 'italic',
      textAlign: 'center',
      margin: '0 0 2rem 0 !important',
    },
    container: {
      flex: '1 1 auto',
      padding: '0 5rem 0.5rem 5rem',
      'overflow-y': 'visible',
    },
    inputFields: {
      justifyContent: 'space-around',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { descript... Remove this comment to see the full error message
export default withStyles(styles)(QualysForm);
